<template>
    <div class="layout-sidebar">
        <div class="flex justify-center mt-4">
            <LogoComponent title color="#FFFFFF" />
        </div>
        <div class="sidebar-scroll">
            <ul class="layout-menu">
                <AppMenuItem v-for="(item, i) in navItems" :key="i" :item="item" :index="i" />
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue'

    import AppMenuItem from './AppMenuItem.vue'
    import LogoComponent from './LogoComponent.vue'

    import { hasRoles } from '@/libs/roles.ts'
    import { getNavItems } from '@/navigation'
    import type { NavLink } from '@/types/Navigation'

    const navItems = computed(() => {
        const allNavItems = getNavItems()

        const processNavLinks = (links: NavLink[]): NavLink[] => {
            const stack: NavLink[] = [...links]
            const result: NavLink[] = []

            while (stack.length > 0) {
                const current = stack.pop() as NavLink
                const shouldInclude
                    = !current.requiredRoles || hasRoles(...current.requiredRoles)

                if (shouldInclude) {
                    const newItem: NavLink = { ...current }
                    if (newItem.items) {
                        newItem.items = processNavLinks(newItem.items) // Process nested items
                    }
                    result.unshift(newItem) // Add processed item to result
                }
            }

            return result
        }

        return processNavLinks(allNavItems)
    })
</script>
